(function () {
          function ready(fn) {
            document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);
          }
          ready(function () {
            // every top-level dropdown — the working logic, applied generically
            document.querySelectorAll('li.t4s-type__drop.has--children').forEach(function (li) {
              var panel = li.querySelector('.t4s-sub-menu');
              if (!panel) return;

              function openOnly(target) {
                panel.querySelectorAll('.t4s-menu-item.has--children').forEach(function (p) {
                  var sub = p.querySelector(':scope > .t4s-sub-menu-2');
                  if (sub) sub.style.display = p === target ? 'block' : '';
                });
              }

              var current = null;
              panel.addEventListener('mouseover', function (e) {
                var parent = e.target.closest('.t4s-menu-item.has--children');
                if (parent && panel.contains(parent) && parent !== current) {
                  current = parent;
                  openOnly(parent);
                }
              });

              li.addEventListener('mouseleave', function () {
                current = null;
                panel.querySelectorAll('.t4s-menu-item.has--children').forEach(function (p) {
                  var sub = p.querySelector(':scope > .t4s-sub-menu-2');
                  if (sub) sub.style.display = '';
                });
              });
            });
          });
        })();